import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { AuthService } from 'src/app/core/services/AuthService';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { NotificacionService } from 'src/app/core/services/notificacion.service';
import { k } from 'src/environments/properties';
import { Subscription, lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { BrandingService } from 'src/app/core/services/branding.service';
import { InstitutionSettings } from 'src/app/core/services/institution-settings.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public right_sidebar: boolean = false;
  public open: boolean = false;
  public openNav: boolean = false;
  public isOpenMobile: boolean;
  public countNotification: number;
  public notificacion: any;
  public userId: any;

  public alerta: any;
  public countAlert: any;

  //SOCKET
  private newUserSubscription: Subscription; // Para el evento 'newUserCreated'
  public contratoEstadoMensaje: any;
  public mensajeNuevoUsuario: string = '';
  public url: string;

  settings: InstitutionSettings | null = null;
  logoUrl: string | null = null;

  returnUrl = 'auth/login';

  @Output() rightSidebarEvent = new EventEmitter<boolean>();

  constructor(
    public navServices: NavService,
    private authService: AuthService,
    private router: Router,
    private websocketService: WebsocketService,
    private notificacionService: NotificacionService,
    public brandingService: BrandingService
  ) {
    this.userId = localStorage.getItem(k.user_id) ?? '';
  }

  collapseSidebar() {
    this.open = !this.open;
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }
  right_side_bar() {
    this.right_sidebar = !this.right_sidebar
    this.rightSidebarEvent.emit(this.right_sidebar)
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }


  ngOnInit() {
    this.logoUrl =
      this.brandingService.getLogoUrl() ||
      'assets/images/dashboard/logo-oscuro.png';
    this.notificaciones();
    this.alertas();
    if (this.websocketService) {
      // Suscribirse al evento 'newUserCreated'
      this.newUserSubscription = this.websocketService.listenForEvent('notificaciones-' + localStorage.getItem(k.user_id)).subscribe(data => {
        this.mensajeNuevoUsuario = data.message;
        this.notificaciones();
      });


    }

    this.brandingService.settings$.subscribe(() => {
      this.logoUrl = this.brandingService.getLogoUrl();
    });


  }


  logout() {
    this.authService.logout();
    this.router.navigate([this.returnUrl]);
  }

  ngOnDestroy(): void {
    if (this.newUserSubscription) {
      this.newUserSubscription.unsubscribe();
    }
  }

  async notificaciones() {
    const userId = localStorage.getItem(k.user_id);
    let params = new HttpParams(); // Inicia un nuevo objeto HttpParams
    params = params.set('usuario_id', userId);
    const response = await lastValueFrom(this.notificacionService.get<any[]>({ params }));
    this.notificacion = response.body;
    this.countNotification = response.body.length;
  }

  async alertas() {
    const userId = localStorage.getItem(k.user_id);
    let params = new HttpParams(); // Inicia un nuevo objeto HttpParams
    params = params.set('usuario_id', userId).set('tipo', 'alerta');
    const response = await lastValueFrom(this.notificacionService.get<any[]>({ params }));
    this.alerta = response.body;
    this.countAlert = response.body.length;
  }

  async deleteNotification(notification: any, index: number) {
    await lastValueFrom(this.notificacionService.deleteById(notification?.id));
    this.notificacion.splice(index, 1);
    this.countNotification = this.notificacion.length;
  }

  async deleteAllNotifications(tipo: string) {
    await lastValueFrom(this.notificacionService.deleteByUsuario(this.userId, tipo));
    if (tipo === 'alerta') {
      this.alertas();
    } else {
      this.notificaciones();
    }

    this.countNotification = this.notificacion.length;
  }

  onLogoError(event: any) {
    if (!event.target.src.includes('logo-oscuro.png')) {
      event.target.src = 'assets/images/dashboard/logo-oscuro.png';
    }
  }

}
